module.exports = __webpack_public_path__ + "img/group2.548b0764.svg";